import type { LegalDoc } from "../types";
import { LEGAL_COMPANY as C } from "../company";

export const communityGuidelines: LegalDoc = {
  slug: "community-guidelines",
  title: "Quy tắc cộng đồng",
  metaTitle: "Quy tắc cộng đồng",
  metaDescription:
    "Quy tắc ứng xử trên Chốt Ca dành cho Nhà tuyển dụng và Người tìm việc ngành F&B, kèm cơ chế báo cáo và xử lý vi phạm.",
  version: "2.0.0",
  effectiveDate: C.effectiveDate,
  intro:
    "Chốt Ca là cộng đồng việc làm F&B, nơi có cả chủ quán cà phê nhỏ lẫn chuỗi nhà hàng, cả bạn sinh viên làm thêm lẫn người làm nghề chuyên nghiệp. Bộ quy tắc dưới đây là mức tối thiểu để mọi người ở đây được an toàn và được tôn trọng. Vi phạm có thể dẫn tới gỡ tin, hạn chế tính năng hoặc chấm dứt tài khoản.",
  sections: [
    {
      title: "1. Tôn trọng lẫn nhau",
      items: [
        "Giao tiếp lịch sự. Không xúc phạm, không miệt thị ngoại hình, giới tính, vùng miền, học vấn hay hoàn cảnh của người khác.",
        "Không phát ngôn thù hằn, kích động bạo lực, kỳ thị tôn giáo hay dân tộc.",
        "**Không quấy rối tình dục** dưới mọi hình thức, gồm lời nói, hình ảnh và gợi ý không phù hợp. Đây là hành vi bị nghiêm cấm theo Điều 8 khoản 3 Bộ luật Lao động 2019 và bị chấm dứt tài khoản ngay lập tức.",
        "Phản hồi đúng hẹn. Thay đổi kế hoạch thì báo trước, đừng im lặng.",
      ],
    },
    {
      title: "2. Dành cho Nhà tuyển dụng",
      items: [
        "Đăng tin trung thực: vị trí công việc có thật, mức lương, ca làm và địa điểm chính xác.",
        "Không đăng tuyển công việc trá hình như đa cấp, môi giới mại dâm, cờ bạc, ma tuý, tín dụng đen.",
        "**Không thu bất kỳ khoản tiền nào từ người tìm việc**, gồm phí ứng tuyển, phí đào tạo, tiền đặt cọc, phí đồng phục, trước khi có hợp đồng lao động.",
        "**Không phân biệt đối xử** dựa trên giới tính, độ tuổi, tình trạng hôn nhân, thai sản, khuyết tật, dân tộc, tôn giáo, quê quán, ngoại hình hay hình xăm — trừ các yêu cầu đặc thù thực sự của công việc và phải nêu rõ trong tin. Chi tiết tại [Thoả thuận dành cho Nhà tuyển dụng](/employer-agreement) mục 4.",
        "**Không tuyển người chưa đủ 18 tuổi** vào các công việc và nơi làm việc mà pháp luật cấm, gồm pha chế và bán đồ uống có cồn, quán bar, karaoke, vũ trường, và ca đêm từ 22:00 tới 06:00.",
        "Trả lương đúng hạn theo thoả thuận. Có tranh chấp thì tôn trọng quy trình hoà giải.",
        "**Tôn trọng quyền riêng tư của ứng viên**: liên hệ trong khung giờ hợp lý, thường là 08:00 tới 21:00, chỉ liên hệ đúng mục đích công việc đã đăng tin, và **xoá thông tin của ứng viên khi không tuyển dụng** theo Điều 25 Luật Bảo vệ dữ liệu cá nhân 2025.",
      ],
    },
    {
      title: "3. Dành cho Người tìm việc",
      items: [
        "Hồ sơ trung thực: kinh nghiệm, kỹ năng và thông tin cá nhân phải đúng sự thật và là của chính bạn.",
        "Chỉ ứng tuyển vào tin bạn thật sự quan tâm. Ứng tuyển đồng nghĩa với việc quán nhận được số điện thoại của bạn ngay lập tức.",
        "Trả lời lời mời phỏng vấn trong 24 giờ. Đến đúng giờ khi đã chốt lịch, hoặc báo huỷ sớm nhất có thể.",
        "Không đòi tiền hoặc lợi ích cá nhân ngoài khuôn khổ thoả thuận lao động hợp pháp.",
        "Tôn trọng nội quy của quán khi đi làm thử hoặc nhận việc.",
        "Không báo cáo sai sự thật nhằm hạ uy tín một quán.",
      ],
    },
    {
      title: "4. Nội dung cấm tuyệt đối",
      body: "Vi phạm các mục dưới đây dẫn tới chấm dứt tài khoản ngay lập tức, không qua bước cảnh cáo:",
      items: [
        "Nội dung khiêu dâm hoặc tình dục hoá dưới mọi hình thức, kể cả dạng ngụ ý.",
        "Tuyển dụng cho ngành nghề trái pháp luật Việt Nam, gồm mại dâm, ma tuý, cờ bạc, tín dụng đen.",
        "Lừa đảo dưới mọi hình thức, gồm việc nhẹ lương cao, yêu cầu chuyển tiền, môi giới đi làm việc ở nước ngoài trái phép.",
        "Mua bán, cho thuê tài khoản; mạo danh người khác; sử dụng giấy tờ giả.",
        "**Mua bán, trao đổi dữ liệu cá nhân** của người dùng khác — hành vi bị nghiêm cấm theo Điều 7 khoản 6 Luật Bảo vệ dữ liệu cá nhân 2025.",
        "Đe doạ, bạo lực, tống tiền, trả thù cá nhân.",
        "Phát tán thông tin cá nhân của người khác khi chưa được đồng ý.",
        "Quảng cáo cờ bạc, vay nặng lãi, ma tuý, vũ khí, chất cấm.",
        "Sử dụng lao động chưa thành niên trái pháp luật.",
      ],
    },
    {
      title: "5. Cơ chế thực thi",
      items: [
        "**Báo cáo**: có sẵn trên mọi tin tuyển dụng, hồ sơ và doanh nghiệp. Chúng tôi xem xét báo cáo về nội dung vi phạm và xử lý trong **24 giờ**.",
        "**Ẩn và chặn**: Người tìm việc ẩn một quán để quán đó không thấy và không mời được mình. Nhà tuyển dụng đưa một người vào danh sách chặn để người đó không ứng tuyển vào tin của mình.",
        "**Gỡ nội dung**: tin hoặc nội dung vi phạm bị gỡ ngay khi được xác minh.",
        "**Cảnh cáo**: với vi phạm mức nhẹ lần đầu, gửi qua thông báo trong ứng dụng hoặc email.",
        "**Hạn chế tính năng**: giới hạn số đơn ứng tuyển hoặc tạm dừng quyền đăng tin.",
        "**Tạm khoá**: từ 07 tới 30 ngày.",
        "**Chấm dứt vĩnh viễn**: với vi phạm nghiêm trọng hoặc tái phạm sau cảnh cáo.",
      ],
    },
    {
      title: "6. Khiếu nại quyết định xử lý",
      body: `Chúng tôi có thể sai. Nếu nội dung của bạn bị gỡ hoặc tài khoản bị hạn chế mà bạn cho rằng chưa đúng, gửi yêu cầu xem xét lại tới **${C.legalEmail}** trong **14 ngày** kể từ khi nhận thông báo, kèm mã tin hoặc mã tài khoản và lập luận của bạn. Chúng tôi phản hồi trong **07 ngày làm việc** và nêu rõ căn cứ của quyết định cuối cùng. Quyết định chấm dứt tài khoản luôn được một người rà lại, không do hệ thống tự động quyết.`,
    },
    {
      title: "7. Báo cáo khẩn cấp",
      body: `Nếu bạn gặp hành vi đe doạ tính mạng, xâm hại tình dục, hoặc lừa đảo có tổ chức, hãy **liên hệ cơ quan công an tại địa phương trước** — số khẩn cấp **113**. Chốt Ca không phải cơ quan chức năng và không có đội trực 24/7, nên chúng tôi không thể thay thế công an trong tình huống khẩn cấp.\n\nSong song đó, gửi email tới **${C.abuseEmail}** kèm bằng chứng gồm ảnh chụp màn hình, mã tin hoặc mã đơn. Chúng tôi ưu tiên xử lý nhóm báo cáo này ngay trong ngày làm việc, khoá tài khoản liên quan khi có căn cứ, và phối hợp cung cấp thông tin cho cơ quan chức năng khi được yêu cầu hợp pháp.`,
    },
  ],
  contact: {
    title: "8. Liên hệ",
    prefix: "Báo cáo vi phạm: ",
    email: C.abuseEmail,
  },
};
